const maritalStatusOptions = [

    {value: 0, label: "Selecciona una opción"},
    {value: 1, label: "Soltero/a"},
    {value: 2, label: "Casado/a"},
    {value: 3, label: "Unión libre"},
]

const genderOptions = [

    {value: 0, label: "Selecciona una opción"},
    {value: 1, label: "Masculino"},
    {value: 2, label: "Femenino"}
]

const educationLevelOptions = [

    {value: 0, label: "Selecciona una opción"},
    {value: 1, label: "Primaria básica"},
    {value: 2, label: "Bachiller"},
    {value: 3, label: "Técnico"},
    {value: 4, label: "Tecnólogo"},
    {value: 5, label: "Profesional pregrado"},
    {value: 6, label: "Profesional posgrado"}

]

const ocupationOptions = [

    {value: 0, label: "Selecciona una opción"},
    {value: 1, label: "Empleado/a"},
    {value: 2, label: "Independiente"},
    {value: 3, label: "Desempleado/a"},
    {value: 4, label: "Pensionado"},
    {value: 5, label: "Ama de casa"},
]

const economicActivityOptions = [

    {value: 0, label: "Selecciona una opción"},
    {value: 1, label: "Agricultura, ganadería"},
    {value: 2, label: "Minería y canteras"},
    {value: 3, label: "Industrias manufactureras"},
    {value: 4, label: "Suministro de servicios"},
    {value: 5, label: "Construcción"},
    {value: 6, label: "Comercio al por mayor y por menor"},
    {value: 7, label: "Transporte y almacenamiento"},
    {value: 8, label: "Alojamiento y comida"},
    {value: 9, label: "Financieros y seguros"},
    {value: 10, label: "Inmobiliarias"},
    {value: 11, label: "Profesionales, cientificas y técnicas"},
    {value: 12, label: "Servicios administrativos"},
    {value: 13, label: "Educación"},
    {value: 14, label: "Salud humana y asistencia"},
    {value: 15, label: "Software y tecnología"},
    {value: 16, label: "Otro"},
]

const monthlyExpensesOptions = [

    {value: 0, label: "Selecciona una opción"},
    {value: 1, label: "Entre $1,300,000 a $2,000,000"},
    {value: 2, label: "Entre $2,000,001 a $3,000,000"},
    {value: 3, label: "Entre $3,000,001 a $5,000,000"},
    {value: 4, label: "Más de $5,000,001"},
]

const stratumOptions = [

    {value: 0, label: "Selecciona una opción"},
    {value: 1, label: "1"},
    {value: 2, label: "2"},
    {value: 3, label: "3"},
    {value: 4, label: "4"},
    {value: 5, label: "5"},
    {value: 6, label: "6"},
]

const creditSituationOptions = [
    {value: 0, label: "Selecciona una opción"},
    {value: 1, label: "Sin reportes negativos"},
    {value: 2, label: "Reporte negativo solo con Bancos"},
    {value: 3, label: "Reporte negativo con Bancos y otras entidades"},
    {value: 4, label: "Reporte negativo solo con Telecomunicaciones"},
    {value: 5, label: "Reporte negativo con otras entidades"}
]

const antiguedadMovilOptions = [
    {value: 0, label: "Selecciona una opción"},
    {value: 1, label: "Menos de 3 meses"},
    {value: 2, label: "Entre 3 y 6 meses"},
    {value: 3, label: "Entre 6 y 12 meses"},
    {value: 4, label: "Más de 12 meses"}
]

const antiguedadCuentaBancariaOptions = [
    {value: 0, label: "Selecciona una opción"},
    {value: 1, label: "Menos de 3 meses"},
    {value: 2, label: "Entre 3 y 6 meses"},
    {value: 3, label: "Entre 6 y 12 meses"},
    {value: 4, label: "Más de 12 meses"}
]

const bankAccountOptions = [
    {value: 0, label: "Selecciona una opción"},
    {value: 1, label: "Banco Agrario de Colombia"},
    {value: 2, label: "Banco AV Villas"},
    {value: 3, label: "Banco BBVA"},
    {value: 4, label: "Banco Caja Social"},
    {value: 5, label: "Banco Citibank"},
    {value: 6, label: "Banco Davivienda"},
    {value: 7, label: "Banco de Bogotá"},
    {value: 8, label: "Banco de Occidente"},
    {value: 9, label: "Banco Falabella"},
    {value: 10, label: "Banco Finandina"},
    {value: 11, label: "Banco GNB Sudameris"},
    {value: 12, label: "Banco Itaú Corpbanca Colombia S.A."},
    {value: 13, label: "Banco Mundo Mujer"},
    {value: 14, label: "Banco Pichincha"},
    {value: 15, label: "Banco Popular"},
    {value: 16, label: "Banco Credifinanciera"},
    {value: 17, label: "Banco Santander de Negocios Colombia S.A."},
    {value: 18, label: "Bancamia S.A"},
    {value: 19, label: "Banco Serfinanza"},
    {value: 20, label: "Bancoldex"},
    {value: 21, label: "Bancolombia"},
    {value: 22, label: "Bancoomeva"},
    {value: 23, label: "BNP Paribas"},
    {value: 24, label: "Coltefinanciera"},
    {value: 25, label: "Financiera Juriscoop"},
    {value: 26, label: "Banco JP Morgan Colombia"},
    {value: 27, label: "Mibanco S.A"},
    {value: 28, label: "Red Multibanca Colpatria"},
    {value: 29, label: "Simple S.A"},
    {value: 30, label: "Nequi"},
    {value: 31, label: "Daviplata"},
]

const bankAccountOptionsFiltered = [
    {value: 0, label: "Selecciona una opción"},
    {value: 1, label: "Banco Agrario de Colombia"},
    {value: 2, label: "Banco AV Villas"},
    {value: 3, label: "Banco BBVA"},
    {value: 4, label: "Banco Caja Social"},
    {value: 5, label: "Banco Citibank"},
    {value: 6, label: "Banco Davivienda"},
    {value: 7, label: "Banco de Bogotá"},
    {value: 8, label: "Banco de Occidente"},
    {value: 15, label: "Banco Popular"},
    {value: 18, label: "Bancamia S.A"},
    {value: 21, label: "Bancolombia"},
    {value: 28, label: "Red Multibanca Colpatria"},
    {value: 30, label: "Nequi"},
    {value: 31, label: "Daviplata"},
]

const typeBankAccountOptions = [

    {value: 0, label: "Selecciona una opción"},
    {value: 1, label: "Ahorros"},
    {value: 2, label: "Corriente"}
    
]

const typeBankAccountOptionsLabel = [

    {value: "Selecciona una opción", label: "Selecciona una opción"},
    {value:  "Ahorros", label: "Ahorros"},
    {value:  "Corriente", label: "Corriente"}
    
]

const hasAccountBank = [

    {value: 0, label: "Selecciona una opción"},
    {value: 1, label: "Si"},
    {value: 2, label: "No"}
    
]

module.exports = {
    maritalStatusOptions,
    genderOptions,
    educationLevelOptions,
    ocupationOptions,
    economicActivityOptions,
    monthlyExpensesOptions,
    stratumOptions,
    bankAccountOptions,
    typeBankAccountOptions,
    creditSituationOptions,
    antiguedadMovilOptions,
    antiguedadCuentaBancariaOptions,
    hasAccountBank,
    bankAccountOptionsFiltered,
    typeBankAccountOptionsLabel
}